<!--创建学期model-->
<template>
    <div>
        <vue-scroll :ops="$ops">
            <el-form  label-width="55px">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="学期">
                            <el-select v-model="semester_id" placeholder="请选择学期" style="width: 200px" disabled>
                                <el-option
                                        v-for="item in  $parentInfo.semesters"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-form>
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>年级</th>
                        <th>时长</th>
                        <th>价格</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(grade,index) in $parentInfo.dialog_GetClassHourDetail.grades_classHour" :key="index">
                        <td>
                            <el-select v-model="grade.grade_id" placeholder="请选择年级" style="width: 200px" disabled>
                                <el-option
                                        v-for="item in  $parentInfo.grades"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-select v-model="grade.time" placeholder="请选择时长" style="width: 200px">
                                <el-option
                                        v-for="item in  $parentInfo.times"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number size="medium" :controls=false v-model="grade.price" placeholder="请输入价格"></el-input-number>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-form>
        </vue-scroll>
        <div class="text-right">
            <el-button type="primary" @click="handleUpdateSemester()"
                       :loading="$parentInfo.dialog_GetClassHourDetail.button_loading">保存
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_CreateSemester",
        data() {
            return {
                semester: {
                    id: '',
                    name: '',
                },
                semester_id:'',
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleClassHourFormat();
        },
        methods: {
            handleClassHourFormat(){
                this.$parentInfo.dialog_GetClassHourDetail.loading = true;
                this.semester_id=this.$store.state.modal.data.semester_id
                this.$wApi.send(this.$parentInfo.path, 'get_classHourDetail', {'semester_id':this.$store.state.modal.data.semester_id});
            },
            //修改课时
            handleUpdateSemester() {
                this.$parentInfo.dialog_GetClassHourDetail.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'update_classHour', {
                    'semester_id':this.semester_id,
                    'classHours': this.$parentInfo.dialog_GetClassHourDetail.classHours,
                });
        },
        }
    }
</script>

<style scoped>
    .text {
        position: absolute;
        left: 25px;
        top: 25px;
    }

    .box_relative {
        position: relative;
    }

    .card-body {
        height: calc(100vh - 125px);
    }

    .card-footer {
        position: fixed;
        width: calc(100% - 20px);
        padding: 5px 10px;
        bottom: 0;
    }
</style>
